module.exports = __webpack_public_path__ + "img/close-model.43d931ce.svg";